const localeObject = {
	en: '🇬🇧 ',
	ie: '🇮🇪 ',
	au: '🇦🇺 ',
	ca: '🇨🇦 ',
	nz: '🇳🇿 ',
};

export default ({ countryCode = 'en' }) => localeObject[countryCode];
